import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {RouterProvider} from "react-router-dom";
import {PrimeReactProvider} from 'primereact/api';
import {addLocale} from 'primereact/api';
import './models/init.js';
import './i18n.js';
import './theme.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import './index.css'
import ru from 'primelocale/ru.json'
import kz from 'primelocale/kk.json'
import routes from './router.jsx'
import dayjs from 'dayjs';
import dayRu from 'dayjs/locale/ru'
import dayKz from 'dayjs/locale/kk'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.locale(dayRu)
const tz = 'Asia/Almaty'
dayjs.tz.setDefault(tz)
window.dayjs = dayjs

addLocale('ru', ru.ru)
addLocale('kz', kz.kk)

createRoot(document.getElementById('root')).render(
  <StrictMode>
      <PrimeReactProvider value={{locale: 'ru'}}>
        <RouterProvider router={routes}/>
      </PrimeReactProvider>
  </StrictMode>,
)
